import React from 'react';
import { Navigate } from 'react-router-dom';
import { getLocalKey } from '../../../utils/commonfunction';
import { useSelector } from 'react-redux';
import GlobalLoader from './globalLoader';
import { STAFF_ROLE } from './../../../utils/Constants';

const PublicRoute = ({ component: Component }) => {
    
    const loaderState = useSelector((state) => state.globalLoader);

    const userData = getLocalKey("admin_user") 
        ? JSON.parse(getLocalKey("admin_user")) 
        : {};

    const allowedRolesForAdminPanel = [
        STAFF_ROLE.SUB_ADMIN,
        STAFF_ROLE.SUPER_ADMIN
    ];

    const isLoggedIn = userData?.token;

    const hasValidRole =
        userData?.role &&
        allowedRolesForAdminPanel.some(role =>
            userData.role.includes(role)
        );

    return (
        <>
            {
                isLoggedIn && hasValidRole ? (
                    <Navigate to="/admin/dashboard" />
                ) : loaderState ? (
                    <GlobalLoader />
                ) : (
                    <Component />
                )
            }
        </>
    );
};

export default PublicRoute;